<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      收货信息
    </div>
    <div class="rj-page-card__content">
      <Collapse :open="true">
        <div slot="header">
          <collapseHeader :data="address" @chooseAddress="(val) => $emit('chooseAddress', val)" />
        </div>

        <productTable ref="productTable" v-bind="$props" :list="productList" />
      </Collapse>
      <slot />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Collapse from '@/components/Collapse';
import CollapseHeader from './collapseHeader.vue';
import ProductTable from './productTable.vue';

export default {
  components: {
    Collapse,
    CollapseHeader,
    ProductTable
  },

  props: {
    rebateAmount: {
      type: [String, Number],
      default: 0
    },
    rebate: {
      type: [Number],
      default: 1
    },
    salesType: {
      type: [String, Number],
      default: ''
    },
    contractType: {
      type: String,
      default: ''
    },
    communicationOrderDiscount: {
      type: [String, Number],
      default: 1
    },
    form: {
      type: Object,
      default: () => { return {}; }
    }
  },

  data () {
    return {
      productList: [],
      loading: false,
      address: {}
    };
  },

  computed: {
    ...mapState({
      freightProperty: state => state.enumeration.freightProperty
    })
  },

  methods: {
    // 发布
    validate () {
      let { productList, summariesData } = this.$refs.productTable.getSubmitData();

      return new Promise((resolve, reject) => {
        if (!productList.length) {
          this.$notify.error({ message: '请选择产品' });
          resolve(false);
          return;
        }

        if (summariesData.beforeSplitProductPriceSigle !== summariesData.orderAmount) {
          this.$notify.error({ message: '拆分前单价与订单金额不符' });
          resolve(false);
          return;
        }

        for (let i = 0; i < productList.length; i++) {
          let item = productList[i];
          if (!item.productCode) {
            this.$notify.error({ message: '存在产品未选产品型号' });
            resolve(false);
            return;
          } else if (!item.materialNumberId) {
            this.$notify.error({ message: '存在产品未选择期料号' });
            resolve(false);
            return;
          } else if (!item.expectedDeliveryDate) {
            this.$notify.error({ message: '存在产品未选择期望发货日期' });
            resolve(false);
            return;
          } else if (!item.freightProperty) {
            this.$notify.error({ message: '存在产品未选择货运属性' });
            resolve(false);
            return;
          } else if (!item.rate) {
            this.$notify.error({ message: '存在产品未选择税率' });
            resolve(false);
            return;
          }
          if ((item.productNumBak || item.productNumBak === 0) && this.contractType !== '服务订单' && this.contractType !== '国际分销下单' && this.contractType !== '国际业务下单') {
            let total = 0;
            productList.forEach((one) => {
              if (one.id === item.id) {
                total += one.productNum;
              }
            });
            if (total !== item.productNumBak) {
              this.$notify.error({ message: `${item.productName}拆行后的数量总和要等于拆行前的数量，请修改后再提交` });
              resolve(false);
              return;
            }
          }
        }

        resolve({ productList: productList, actualSettlementAmount: summariesData.settlementAmount, orderSales: summariesData.orderAmount });
      });
    },

    validateDraft () {
      let { productList, summariesData } = this.$refs.productTable.getSubmitData();

      return new Promise((resolve) => {
        if (this.contractType !== '服务订单' && this.contractType !== '国际分销下单' && this.contractType !== '国际业务下单') {
          for (let i = 0; i < productList.length; i++) {
            let item = productList[i];
            if (item.productNumBak || item.productNumBak === 0) {
              let total = 0;
              productList.forEach((one) => {
                if (one.id === item.id) {
                  total += one.productNum;
                }
              });
              if (total !== item.productNumBak) {
                this.$notify.error({ message: `${item.productName}拆行后的数量总和要等于拆行前的数量，请修改后再提交` });
                resolve(false);
                return;
              }
            }
          }
        }
        resolve({ productList: productList, actualSettlementAmount: summariesData.settlementAmount, orderSales: summariesData.orderAmount });
      });
    }
  }

};
</script>

<style lang="scss">
  .rj-page-card{
    .table{
      .el-table{
       .red-row {
          background:  #f0f9eb;
          }
        .cell{
          padding-left: 0;
          padding-right: 0;
        }
      }
    }
  }
</style>
